import React, { useCallback, useRef } from 'react';
import Popper from '#web-components/components/Popper';
import MdtuButton from '#web-components/components/Button';
import IconButton from '#web-components/components/IconButton';
import { ButtonType, PopperButtonProps } from '#web-components/types/popper';

const ButtonComponents = {
  default: MdtuButton,
  icon: IconButton,
};

export default function PopperButton({
  children, placement, timeout, buttonProps, buttonType, zIndex, disablePortal,
}: PopperButtonProps) {
  const buttonRef = useRef<HTMLButtonElement | null>(null);
  const [open, setOpen] = React.useState<boolean>(false);

  const handleClose = useCallback(() => {
    setOpen(false);
  }, []);

  const handleClick = useCallback(() => {
    setOpen((prevState) => !prevState);
  }, []);

  const Button = ButtonComponents[buttonType || ButtonType.default];
  return (
    <>
      <Button
        {...buttonProps}
        buttonRef={buttonRef}
        onClick={handleClick}
      />
      <Popper
        zIndex={zIndex}
        open={open}
        anchorEl={buttonRef}
        placement={placement}
        timeout={timeout}
        onClose={handleClose}
        disablePortal={disablePortal}
      >
        {children}
      </Popper>
    </>
  );
}
